export default __webpack_public_path__ + "static/media/AdobeStock_285756278.2638164a.jpg";